import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, Router, UrlTree } from '@angular/router';
import { AuthService } from '../services/auth.service';
import { AccountType } from '../models/enums/account-type.enum';

/**
 * AccountTypeGuard
 *
 * Sprawdza czy użytkownik ma odpowiedni typ konta (CANDIDATE / COMPANY)
 * dla danej trasy. Jeśli nie — przekierowuje na /dashboard.
 *
 * Użycie w routes:
 * { path: 'cv', data: { accountTypes: [AccountType.CANDIDATE] }, canActivate: [AuthGuard, AccountTypeGuard] }
 */
@Injectable({ providedIn: 'root' })
export class AccountTypeGuard {
  constructor(
    private readonly router: Router,
    private readonly authService: AuthService,
  ) {}

  canActivate(route: ActivatedRouteSnapshot): boolean | UrlTree {
    const allowedTypes = route.data['accountTypes'] as AccountType[] | undefined;

    if (!allowedTypes || allowedTypes.length === 0) {
      return true;
    }

    const user = this.authService.getCurrentUser();

    if (!user || !allowedTypes.includes(user.accountType)) {
      return this.router.createUrlTree(['/dashboard']);
    }

    return true;
  }
}
